<template>

    <v-card
      @drop.prevent="onDrop($event)"
      @dragover.prevent="dragover = true"
      @dragenter.prevent="dragover = true"
      @dragleave.prevent="dragover = false"
      :class="{ 'grey lighten-2': dragover }"
          min-height="200"
    >
      <v-card-text>
        <v-row class="d-flex flex-column" dense align="center" justify="center">
          <a   @click="$refs.file.click()">
          <v-icon :class="[dragover ? 'mt-2, mb-6' : 'mt-5']" size="60">
            mdi-cloud-upload
          </v-icon>
          </a>

                  <input type="file" multiple name="fields[assetsFieldHandle][]" id="assetsFieldHandle" 
      style=" opacity:0; position:absolute; overflow:hidden;  cursor: pointer;" @change="onChange" ref="file" /> <!-- accept=".pdf,.jpg,.jpeg,.png"-->
  
    <label for="assetsFieldHandle" style="cursor: pointer;">
      <div>
                  <p>
            Drop your text file(s) here, or click to select them.
          </p>
      </div>
    </label>
    <div v-if="uploadedFiles.length > 0">
    <label>  {{uploadedFiles[0].name}}  </label>         
      <v-btn class="ml-4"  @click.stop="submit">
          <v-icon id="upload-button">mdi-upload</v-icon> Process File
      </v-btn>
    </div>
        </v-row>
      
      </v-card-text>

    </v-card>

</template>

<script>
export default {
  name: "Upload",
  data() {
    return {
      dragover: false,
      uploadedFiles: [],
      multiple: false,
    };
  },
  methods: {
          onChange() {
              this.uploadedFiles = []
     this.uploadedFiles.push(this.$refs.file.files[0])
    },

    onDrop(e) {
      this.dragover = false;
      // If there are already uploaded files remove them
      if (this.uploadedFiles.length > 0) this.uploadedFiles = [];
      // If user has uploaded multiple files but the component is not multiple throw error
      if (!this.multiple && e.dataTransfer.files.length > 1) {
        alert("Maximum number of files: 1")
      }
      // Add each file to the array of uploaded files
      else
        e.dataTransfer.files.forEach(element =>
          this.uploadedFiles.push(element)
        );
    },
    submit() {
      // If there aren't any files to be uploaded throw error
      if (!this.uploadedFiles.length > 0) {
          return
      } else {
        // Send uploaded files to parent component
        this.$emit("readLocalFile", this.uploadedFiles[0]);
        // Close the dialog box
      }
    }
  }
};
</script>